let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let DateRange = require("ES/widgets/DateRange");
let esStatusImage = require("../calendar_area/esStatusImage");
let AuthedUserSession = require("../../../utils/AuthedUserSession");
let Constants = require("../../../utils/Constants.js");
let esUtils = require("ES/utils/esUtils");

/**
 * Open an external window
 * @param opentocontact_url
 * @param crmkind
 * @returns {*}
 * @private
 */
let __onClickExternalCRM = function (opento_url, crmkind) {
  return esUtils.wrapPreventDefault(function () {
    let CRMWindowName = _.get(
      Constants,
      [
        "GRAB_SERVICES_WITH_DEEP_INTEGRATION",
        crmkind.toUpperCase(),
        "browser_window_name",
      ],
      "genericcrm"
    );
    window.open(opento_url, CRMWindowName); //, CRMWindowName, "height=700,width=1024").focus();
  });
};

/**
 * Given an external CRM id (like "KARMACRM:12345"), figure out if we should
 * offer a link to that lead in the external app.
 *
 * This depends on /authenticate/getdisplaylists sending over data in the perspeaker.xxx.crm_sso key
 * with a value for lead_url that looks like "https://app.hubspot.com/contacts/6224665/contact/{id}/"
 * where {id} will be replaced with the lead ID.
 *
 * @param event
 * @param crm_sso
 * @returns {{crmkind: null, opento_url: null}}
 * @private
 */
let __computeExternalCRMLink = function (event, crm_sso) {
  //possibly link to external CRM (contact.externalid = "KARMACRM:12345", for example)
  let opento_url = null;
  let crmkind = null;

  let externalid = _.get(event, "foreignKey", "");
  externalid = "string" === typeof externalid ? externalid.split(":") : [];
  if (2 === externalid.length) {
    //we have an id for an external in the form of KARMACRM:123456
    crmkind = externalid[0];
    if (
      !_.isEmpty(
        _.get(Constants, ["GRAB_SERVICES_WITH_DEEP_INTEGRATION", crmkind])
      )
    ) {
      opento_url = _.get(_.find(crm_sso, { kind: crmkind }), "lead_url");
      if (!_.isEmpty(opento_url)) {
        opento_url = opento_url.replace("{id}", externalid[1]);
      }
    }
  }
  return { opento_url, crmkind };
};

module.exports = dd.createClass({
  __changeActiveCompany: function (company_id) {
    AuthedUserSession.setLastSelectedCompany(company_id);
    window.location.reload();
  },
  __onCopy: esUtils.wrapPreventDefault(function (e) {
    let textArea = document.createElement("textarea");
    textArea.value = this.props.event.eid;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();

    this.setState({ copySuccess: true });
  }),
  render() {
    let event = this.props.event,
      Displaylists = this.props.Displaylists,
      custom_status_text = this.props.custom_status_text,
      my_speaker_names_by_sid,
      speaker_names,
      event_time = null,
      event_venue = null;

    if (!event || event.eid < 1) {
      return dd.div();
    }

    my_speaker_names_by_sid = _.object(
      _.map(Displaylists.perspeaker, function (speaker) {
        return [speaker.sid, speaker.name_full];
      })
    );
    speaker_names = _.map(event.sids, function (sid) {
      return my_speaker_names_by_sid[sid];
    }).join(", ");

    if (event.starttime || event.stoptime) {
      event_time = DateRange({
        start: event.starttime,
        start_format: "dddd, mmmm d, yyyy",
        stop: event.stoptime,
      });
    } else {
      event_time = dd.div(
        {},
        dd.span({ className: "DateRange fa-calendar fa" }),
        " (no stagetimes)"
      );
    }
    if (event.deliveryMethod === Constants.DELIVERY_METHOD_INTEGERS.ONSITE) {
      event_venue = dd.div(
        {},
        dd.span({ className: "fa fa-map-marker venue" }),
        _.uniq(
          _.map(event.Stagetime, function (v) {
            return _.get(
              _.find(event.Venue, { id: v.venueid.toString() }),
              "st",
              "..."
            );
          })
        ).join(", ")
      );
    } else if (
      event.deliveryMethod === Constants.DELIVERY_METHOD_INTEGERS.VIRTUAL
    ) {
      event_venue = dd.div(
        {},
        dd.span({ className: "fa fa-video-camera venue" }),
        dd.a({ href: event.zoomUrl }, "Launch Video Conference")
      );
    } else {
      event_venue = dd.div(
        {},
        dd.span({ className: "fa fa-map-marker venue" }),
        _.map(
          _.filter(
            _.get(Displaylists, "universal.deliverymethods", {}),
            function (dm) {
              return _.get(dm, "id") == _.get(event, "deliveryMethod");
            }
          ),
          "description"
        ).join(", ")
      );
    }

    let status_text = _.isString(custom_status_text)
      ? custom_status_text
      : event.status;

    let isOtherCompany = !_.include(
      _.get(AuthedUserSession, ["activeCompanyIds"]),
      _.parseInt(_.get(event, ["companyID"]))
    );

    let crmlink = _.get(Displaylists, ["perspeaker"]);
    crmlink = _.find(crmlink, { sid: event.sids[0] });
    crmlink = _.get(crmlink, "crm_sso", []);
    let { opento_url, crmkind } = __computeExternalCRMLink(event, crmlink); //trouble if multiple speakers on event, but that's rare

    let status_eval_icon = "img/light-null.png";
    if (_.get(event, ["Evaluation", "not_evaluated"], true)) {
      status_eval_icon = "img/light-not.png";
    } else {
      if (parseFloat(_.get(event, ["Evaluation", "score"])) >= 4.2) {
        status_eval_icon = "img/light-green.png";
      } else if (parseFloat(_.get(event, ["Evaluation", "score"])) >= 3.8) {
        status_eval_icon = "img/light-yellow.png";
      } else if (parseFloat(_.get(event, ["Evaluation", "score"])) > 0) {
        status_eval_icon = "img/light-red.png";
      }
    }

    return dd.div(
      {
        className:
          event.status +
          " EventHeader well well-sm" +
          (_.isEmpty(event.sids) ? " job" : ""),
      },
      dd.div(
        { className: "pull-left", style: { marginRight: 10 } },
        esStatusImage({
          status: event.status,
          delivery_method: event.deliveryMethod,
          has_parent: event.parentID > 0,
          has_children: !_.isEmpty(event.childevents),
          closed: (_.get(event, "flags", 0) & 4) > 0,
        })
      ),
      dd.div(
        null,
        dd.h4(
          { className: "status" },
          status_text,
          dd.img({
            className: "pull-right",
            src: status_eval_icon,
            style: { marginLeft: "0.5rem", width: "18px", height: "18px" },
          })
        ),
        isOtherCompany
          ? dd.h4(
              null,
              "[" +
                _.get(
                  _.indexBy(
                    _.get(Displaylists, ["universal", "company"]),
                    "id"
                  ),
                  [_.get(event, ["companyID"]), "abbr"],
                  "other company"
                ).toUpperCase() +
                "] event"
            )
          : dd.h4(null, event.organization),
        dd.div(
          { className: "event-details" },
          dd.span(
            { className: "pull-right" },
            speaker_names,
            _.isEmpty(speaker_names) ? null : " ",
            dd.a(
              {
                onClick: this.__onCopy,
                style: {
                  marginRight: "0.5rem",
                  marginLeft: "0.5rem",
                  color: _.get(this.state, "copySuccess", false)
                    ? "green"
                    : "#428BCA",
                },
              },
              dd.i({ className: "fa fa-clipboard" })
            ),
            event.eid,
            _.get(event, "accountinglocked")
              ? dd.div(
                  { className: "text-right" },
                  dd.i({ className: "fa fa-lock" }),
                  " Accounting locked"
                )
              : null,
            opento_url
              ? dd.div(
                  { className: "text-right" },
                  dd.a(
                    {
                      href: opento_url,
                      onClick: __onClickExternalCRM(opento_url, crmkind),
                    },
                    "CRM ",
                    dd.i({
                      className: "fa fa-external-link",
                      style: { marginLeft: "0.25rem" },
                    })
                  )
                )
              : null,
            _.isEmpty(opento_url) && !_.isEmpty(_.get(event, "foreignKey"))
              ? dd.div(
                  { className: "text-right" },
                  dd.i({ className: "fa fa-link" }),
                  " CRM"
                )
              : null
          ),
          event_time,
          " ",
          event_venue
        ),
        isOtherCompany
          ? dd.div(
              {
                className: "text-danger text-center",
                style: { marginTop: 10 },
              },
              "To view this event, ",
              dd.span(
                {
                  className: "text-primary",
                  onClick: () =>
                    this.__changeActiveCompany(_.get(event, ["companyID"])),
                  style: { cursor: "pointer", textDecoration: "underline" },
                },
                " change your active company  to " +
                  _.get(
                    _.indexBy(
                      _.get(Displaylists, ["universal", "company"]),
                      "id"
                    ),
                    [_.get(event, ["companyID"]), "name"],
                    "match this event"
                  ).toUpperCase() +
                  "."
              )
            )
          : null,
        AuthedUserSession.doIHaveAccess.read.all(event.sids)
          ? dd.div(
              {
                className: "text-danger text-center",
                style: { marginTop: 10 },
              },
              "You are in READ ONLY mode and cannot save changes."
            )
          : null
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/EventHeader.js